import { LoaderDeprecated } from '../../_DEPRECATED/LoaderDeprecated';
import { Loader } from '../Loader.component';

import { AdapterLoaderProps, PropsHelper, isNewLoaderProps } from './AdapterLoader.types';

export const AdapterLoader = (props: AdapterLoaderProps & PropsHelper) => {
  // @ts-expect-error isNewLoaderProps should be enough
  if (isNewLoaderProps(props)) return <Loader {...props} />;
  // @ts-expect-error isNewLoaderProps should be enough
  return <LoaderDeprecated {...props} />;
};
